import React from "react";

const EyeOpen = () => {
  return (
    <div>
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          stroke="#858796"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        >
          <path d="m21.2572 10.9622c.4742.6191.4742 1.4565 0 2.0756-1.4932 1.949-5.0754 5.9622-9.2572 5.9622-4.18177 0-7.76402-4.0132-9.25716-5.9622-.47427-.6191-.47428-1.4565-.00001-2.0756 1.49315-1.94899 5.0754-5.9622 9.25717-5.9622 4.1818 0 7.764 4.01321 9.2572 5.9622z" />
          <circle cx="12" cy="12" r="3" />
        </g>
      </svg>
    </div>
  );
};

export default EyeOpen;
